import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/dottori/DottoriList.vue'),
		meta: {
			title: 'doctors',
			acl: 'section.dottori'
		}
	},
	
];

export default routes;